import { render, staticRenderFns } from "./PurPrepaymentModal.vue?vue&type=template&id=67b448fe&scoped=true&"
import script from "./PurPrepaymentModal.vue?vue&type=script&lang=js&"
export * from "./PurPrepaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./PurPrepaymentModal.vue?vue&type=style&index=0&id=67b448fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b448fe",
  null
  
)

export default component.exports